/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Raifragen } from '../../models/raifragen';

export interface ApiRaifragenGet$Json$Params {
}

export function apiRaifragenGet$Json(http: HttpClient, rootUrl: string, params?: ApiRaifragenGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Raifragen>>> {
  const rb = new RequestBuilder(rootUrl, apiRaifragenGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Raifragen>>;
    })
  );
}

apiRaifragenGet$Json.PATH = '/api/Raifragen';
